// extracted by mini-css-extract-plugin
export default {"primary-font":"CruiseOrders_primary-font__JgRAs","secondary-font":"CruiseOrders_secondary-font__AgwGO","virtual-code":"CruiseOrders_virtual-code__WInPg"};